"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.thorTradeApproveInfinite = void 0;
const types_1 = require("@shapeshiftoss/types");
const api_1 = require("../../../api");
const erc20_abi_1 = require("../../utils/abi/erc20-abi");
const constants_1 = require("../../utils/constants");
const helpers_1 = require("../../utils/helpers/helpers");
const constants_2 = require("../utils/constants");
const thorTradeApproveInfinite = async ({ deps, input, }) => {
    try {
        const { adapterManager, web3 } = deps;
        const { quote, wallet } = input;
        const approvalQuote = {
            ...quote,
            sellAmount: constants_2.MAX_ALLOWANCE,
            feeData: {
                ...quote.feeData,
                chainSpecific: {
                    ...quote.feeData.chainSpecific,
                    // Thor approvals are cheaper than trades, but we don't have dynamic quote data for them.
                    // Instead, we use a hardcoded gasLimit estimate in place of the estimatedGas in the Thor quote response.
                    estimatedGas: constants_1.APPROVAL_GAS_LIMIT,
                },
            },
        };
        const sellAssetChainId = approvalQuote.sellAsset.chainId;
        const adapter = adapterManager.get(types_1.KnownChainIds.EthereumMainnet);
        if (!adapter)
            throw new api_1.SwapError(`[thorTradeApproveInfinite] - No chain adapter found for ${sellAssetChainId}.`, {
                code: api_1.SwapErrorTypes.UNSUPPORTED_CHAIN,
                details: { sellAssetChainId },
            });
        const allowanceGrantRequired = await (0, helpers_1.grantAllowance)({
            quote: approvalQuote,
            wallet,
            adapter,
            erc20Abi: erc20_abi_1.erc20Abi,
            web3,
        });
        return allowanceGrantRequired;
    }
    catch (e) {
        if (e instanceof api_1.SwapError)
            throw e;
        throw new api_1.SwapError('[zrxApproveInfinite]', {
            cause: e,
            code: api_1.SwapErrorTypes.APPROVE_INFINITE_FAILED,
        });
    }
};
exports.thorTradeApproveInfinite = thorTradeApproveInfinite;
